import type { FormJson } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import { AppSchemaEntityToDto } from "src/app/features/ApplicationSchema/services/mappers/AppSchemaEntityToDto";
import { getAssignedDataGroup } from "../../../../../core/router/auth/SecurityManager";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../../core/service/baseApi";
import type { GenericObject } from "../../../../../core/types";

export const defaultAppConfigApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        saveAppSchema: builder.mutation<GenericObject, FormJson>({
            query: (schema) => {
                const dataGroup = getAssignedDataGroup();
                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.APP_SCHEMA}`;
                const method = "PUT";

                const body = AppSchemaEntityToDto(schema);
                return {
                    url,
                    method,
                    body,
                };
            },
            invalidatesTags: ["appConfigurations"],
        }),
    }),
});

export const { useSaveAppSchemaMutation } = defaultAppConfigApi;
